import React, { useEffect, useState } from "react"
import Select from "react-select"

import { GET, httpOk } from "helpers/api"
import AnalyticsMonthly from "pages/partner/AnalyticsMonthly"

/**
 * Пришли и ушли — тот же блок, что у партнёра в кабинете, по всей базе.
 *
 * Выбран партнёр — показывается его ветка (он сам, агенты и их субагенты), и цифры совпадают
 * с тем, что партнёр видит у себя: расчёт на бэке общий (PointFlowService). Таблица агентов
 * внутри блока: без партнёра в ней партнёры верхнего уровня и точки без партнёра.
 * Период у вкладки свой (3 / 6 / 12 мес.), общий переключатель страницы её не касается.
 */
function Flow() {
	const [partners, setPartners] = useState([])
	const [partnerId, setPartnerId] = useState(null)

	async function getPartners() {
		const response = await GET("/admin/helper/partners")
		if (httpOk(response)) setPartners(response.data)
	}

	useEffect(() => {
		getPartners()
	}, [])

	const partnerFilter = (
		<div style={{ minWidth: "260px" }}>
			<Select
				isClearable
				options={partners}
				value={partners.find((option) => option.id === partnerId) || null}
				onChange={(option) => setPartnerId(option ? option.id : null)}
				placeholder="Все партнёры"
				noOptionsMessage={() => "Не найдено"}
				getOptionLabel={(option) => `${option.name || ""} (${option.login})`}
				getOptionValue={(option) => option.id}
			/>
		</div>
	)

	return (
		<AnalyticsMonthly
			url="/admin/analytics/monthly"
			params={partnerId ? { partner_id: partnerId } : {}}
			filters={partnerFilter}
			withSummary
		/>
	)
}

export default Flow
